<template>
    <b-sidebar
      id="sidebar-search"
      :title="getSidebarLabel"
      header-class="label-header"
      :bg-variant="bg_variant"
      :text-variant="text_variant"
      body-class="sidebar-body"
      backdrop
      shadow="lg"
      @shown="shown"
    >
        <b-overlay :show="loading">
            <b-form @submit.stop.prevent="submit('query')">
                <div id="div-search-sidebar">
                    <b-row class="mt-2">
                        <b-col cols="12" class="px-4">
                            <b-input-group class="mb-2">
                                <b-input-group-prepend is-text>
                                    <b-icon icon="search"></b-icon>
                                </b-input-group-prepend>
                                <b-form-input
                                    id="search-query"
                                    ref="search-query"
                                    v-model="model.query"
                                    type="text"
                                    placeholder="Keyword Search"
                                    autofocus
                                    autocomplete="off"
                                    @focus="model.query=null"
                                ></b-form-input>
                                <b-input-group-prepend>
                                    <b-button type="submit" size="sm" variant="dark">Go</b-button>
                                </b-input-group-prepend>
                            </b-input-group>
                            <!--
                            Query: {{model.query}}
                            <br>
                            <b-link to="/search?q=water">water search 1</b-link>
                            <b-link @click.prevent="search('water')">water search 2</b-link>
                            -->
                        </b-col>
                    </b-row>
                    <b-row class="mt-4">
                        <b-col cols="12" class="px-4">
                            <b-form-group label="Category Filter" label-for="select-cat">
                                <b-form-select id="select-cat" @change="submit('cat')" placeholder="Search by Category" v-model="model.catId" :options="categories"></b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row class="mt-2">
                        <b-col cols="12" class="px-4">
                            <b-form-group label="Company Filter" label-for="select-comp">
                            <b-form-select id="select-comp" @change="submit('comp')" v-model="model.compId" :options="companies"></b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row v-if="this.model.path != '/search'" class="mt-2">
                        <b-col cols="12" class="px-4">
                            <b-form-checkbox
                            id="search-all-content"
                            v-model="searchAllContent"
                            name="search-all-content"
                            value="1"
                            unchecked-value="0"
                            >
                            Include All Content
                            </b-form-checkbox>
                            <!-- <div>State: <strong>{{ searchAllContent }}</strong></div> -->
                        </b-col>
                    </b-row>

                    <!-- <div class="px-3 py-2">
                        <b-form-group label="Backdrop variant" label-for="backdrop-variant">
                        <b-form-select id="backdrop-variant" v-model="variant" :options="variants"></b-form-select>
                        </b-form-group>
                    </div> -->
                </div>
            </b-form>
        </b-overlay>
    </b-sidebar>
</template>

<script>
'use strict'
/* eslint-disable */

import service from "@/service/service"
import utils from "@/utils/utils"
import EventBus from '@/plugins/eventbus'

let data = {
    debug: false,
    loading: false,
    model: {path: '/search', catId: '0', compId: '0', query: ''},
    searchAllContent: '0',
    smallWords: [],
    categories: [],
    companies: [],
    bg_variant: 'light',
    text_variant: 'dark',
    variants: [
        'transparent',
        'white',
        'light',
        'dark',
        'primary',
        'secondary',
        'success',
        'danger',
        'warning',
        'info',
    ],
    categoriesTest: [
        {
            "value": '107',
            "text": "Adhesives/Cements"
        },
        {
            "value": '136',
            "text": "Air Abrasion"
        },
        {
            "value": '133',
            "text": "Anesthesia"
        }
    ],
    companiesTest: [
        {
            "value": '75',
            "text": "Bisco"
        },
        {
            "value": '105',
            "text": "Brasseler USA"
        },
        {
            "value": '89',
            "text": "Centrix"
        },
        {
            "value": '35',
            "text": "Ceramir (Doxa Dental)"
        },
        {
            "value": '99',
            "text": "Clinician's Choice"
        }
    ]
}

// category/company lists from
// http://localhost:3000/api/search-items?s=2EE008DE-16BB-4F2B-AB02-5714848F9421

export default {
  name: "SearchSidebar",
  data() {
    return data
  },
  computed: {
    getSidebarLabel() {
        return (this.searchAllContent == '1') ? 'Search All Content' : this.model.label
    }
  },
  methods: {
      getTextFromValue(value, textArr) {
        // textArr is array of {value: '', text: ''}
        // use for instead of array.forEach due to short-circuit
        for(let ix=0; ix < textArr.length; ix++) {
            // console.log( `Testing ${ix}: value: ${value}  arrVal: ${textArr[ix].value}  arrText:  ${textArr[ix].text}`)
            if (textArr[ix].value == value) { return textArr[ix].text }
        }
        return 'not found'
      },
      submit(searchType) {   // searchType = query (default), cat, comp
        // console.log(`Searching: path: ${this.model.path} cid: ${this.model.catId} coid: ${this.model.compId} q: ${this.model.q}`)
        // alert(`Searching: searchType: ${searchType} q: ${this.model.q}`)
        let searchDisplay = null
        this.model.query = utils.safeSearch(this.model.query)
        if (searchType == 'cat') {
            this.model.compId = null
            this.model.query = null
            searchDisplay = `Category: ${this.getTextFromValue(this.model.catId, this.categories)}`
        }
        else if (searchType == 'comp') {
            this.model.catId = null
            this.model.query = null
            searchDisplay = `Company: ${this.getTextFromValue(this.model.compId, this.companies)}`
        }
        else {  // query
            this.model.catId = null
            this.model.compId = null
            searchDisplay = this.model.query
        }
        this.$root.setSearchDisplay(searchDisplay)

        // If check box checked then search all content - not just filtered
        let path = (this.searchAllContent == "0")  ? this.model.path : '/search'
        this.$router.push({ path: path, query: {cid: this.model.catId, coid: this.model.compId, q: this.model.query, j: (new Date).getTime() }})
      },
    //   search(txt) {
    //     this.$router.push(`/search?q=${txt}`)
    //   },
      shown() {  // when sidebar opened
        // console.log(`sidebar shown.  path: ${this.$route.path} fullPath ${this.$route.fullPath}`)
        this.searchAllContent = "0"
        this.model.catId = null
        this.model.compId = null
        this.model.query = null
        this.$refs['search-query'].focus()
      },
      hidden() {
          // console.log(`sidebar hidden`)
      },
  },
  created() {
    if (this.categories.length === 0 || this.companies.length === 0) {
      this.loading = true
      service
        .getSearchItems()
        .then(res => {
          if (this.debug) console.log(res);
          if (res.status) {
            this.smallWords = res.smallWords
            this.categories.push( { value: null, text: 'Filter by category' } )
            res.catList.forEach( row => {
                this.categories.push( { value: row.categoryID.toString(), text: row.categoryName } )
            })
            this.companies.push( { value: null, text: 'Filter by company' } )
            res.companyList.forEach( row => {
                this.companies.push( { value: row.companyID.toString(), text: row.companyName } )
            })
          } else {
            alert('Error loading filters.')
          }
        })
        .finally(() => this.loading = false)
        .catch(e => console.log(e));
    }
  },
  mounted() {
    EventBus.$on('search-sidebar', model => {
        // console.log(`Event: search-sidebar`)
        this.model = {...model}  // clone
        this.model.query = utils.safeSearch(this.model.query)
        // sidebar opened via v-b-toggle in searchbar.vue
    })
  },
  beforeDestroy() {}
};
</script>

<style>
    /* Assigned to sidebar title.  Needs to be qualified to override default. */
    .b-sidebar > .label-header {
        font-size: 1rem;
    }

    #div-search-sidebar {
        /* border: 1px solid red; */
        /* background-color: #f3f4f9; */
        margin: auto;
    }

    .sidebar-body {
        background-color: #f3f4f9;
    }
</style>


// WEBPACK FOOTER //
// src/components/SearchSidebar.vue